import { TMode, Typography } from 'shared/ui/typography';
import { BasicCard } from '../basicCard';
import { FC, ReactNode } from 'react';
import { TVariant } from '../basicCard/types';
import { DANGER_COLOR } from 'shared/consts';

interface CardProps {
	children: ReactNode;
	variant?: TVariant;
	fitContent?: boolean;
	padding?: string;
	redBorder?: boolean;
  mode?: TMode
}

export const TextCard: FC<CardProps> = ({
	variant = 'default',
	fitContent = true,
	children,
	padding,
	redBorder = false,
  mode = 'medium'
}) => {
	return (
		<BasicCard
			variant={variant}
			fitContent={fitContent}
			styles={{ padding: padding || '4px 8px', border: redBorder ? `${DANGER_COLOR}` : undefined }}
		>
			<Typography mode={mode}>{children}</Typography>
		</BasicCard>
	);
};
